import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { ToasterService } from '../toaster/toaster.service';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthguardService implements CanActivate {

  constructor(private router: Router,private toaster:ToasterService, public auth: AuthenticationService) { }
  
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let authToken = this.auth.isAuthenticated();
    let pagePath = state.url;

    let checkOtp =  pagePath.search("password");
    let checkLogin = pagePath.search('login');
    let trems =  pagePath.search('terms-and-conditions');
    let profileImage = pagePath.search('upload-profile-image');
    let dob = pagePath.search('date-of-birth');
    let anniversary = pagePath.search('date-of-anniversary'); 
    let interests = pagePath.search('interests');

    console.log([pagePath, 'checkOtp:'+checkOtp,"login:"+checkLogin]);
    window.localStorage.setItem('pageUrl',state.url);
      if (authToken) {
          // logged in so return true
          if(checkOtp !== -1) return false;
          if(checkLogin !== -1) return false;
          if(trems !== -1) return false;
          if(profileImage !== -1) return false;
          if(dob !== -1) return false;
          if(anniversary !== -1) return false;
          if(interests !== -1) return false;
          
          return true;
      }
      
        if(checkOtp != -1)return true;
        if(checkLogin !== -1)return true;
        if(trems !== -1) return true;
        if(profileImage !== -1) return true;
        if(dob !== -1) return true;
        if(anniversary !== -1) return true;
        if(interests !== -1) return true;
          

        this.toaster.presentToast("Please login!");

      // not logged in so redirect to login page with the return url and return false
      // this.router.navigate(['login'], { queryParams: { returnUrl: state.url }});
      return false;
  }
}
